export const iconFontAwesomeWeatherTemperatureEmpty = (
	<i className="fa-solid fa-temperature-empty"></i>
);
